import React from 'react';
import { List, Datagrid, TextField, CreateButton, TopToolbar } from 'react-admin';

const QuoteListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export const QuoteList = () => (
  <List 
    actions={<QuoteListActions />}
    empty={
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ marginBottom: '20px' }}>No quotes</div>
        <CreateButton />
      </div>
    }
  >
    <Datagrid>
      <TextField source="quote_text" label="Quote Text" />
      <TextField source="author_name" label="Author" />
    </Datagrid>
  </List>
);

